export default __webpack_public_path__ + "static/media/location.2a8283c8.svg";